var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgI12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 231"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17 16H13C12.45 16 12 16.45 12 17V21C12 21.55 12.45 22 13 22H17C17.55 22 18 21.55 18 21V17C18 16.45 17.55 16 17 16ZM16 20H14V18H16V20Z",
    fill: "#0A71FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25 16H21C20.45 16 20 16.45 20 17V21C20 21.55 20.45 22 21 22H25C25.55 22 26 21.55 26 21V17C26 16.45 25.55 16 25 16ZM24 20H22V18H24V20Z",
    fill: "#0A71FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M33 16H29C28.45 16 28 16.45 28 17V21C28 21.55 28.45 22 29 22H33C33.55 22 34 21.55 34 21V17C34 16.45 33.55 16 33 16ZM32 20H30V18H32V20Z",
    fill: "#0A71FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17 24H13C12.45 24 12 24.45 12 25V29C12 29.55 12.45 30 13 30H17C17.55 30 18 29.55 18 29V25C18 24.45 17.55 24 17 24ZM16 28H14V26H16V28Z",
    fill: "#0A71FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M25 24H21C20.45 24 20 24.45 20 25V29C20 29.55 20.45 30 21 30H25C25.55 30 26 29.55 26 29V25C26 24.45 25.55 24 25 24ZM24 28H22V26H24V28Z",
    fill: "#0A71FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M33 24H29C28.45 24 28 24.45 28 25V29C28 29.55 28.45 30 29 30H33C33.55 30 34 29.55 34 29V25C34 24.45 33.55 24 33 24ZM32 28H30V26H32V28Z",
    fill: "#0A71FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M17 32H13C12.45 32 12 32.45 12 33V37C12 37.55 12.45 38 13 38H17C17.55 38 18 37.55 18 37V33C18 32.45 17.55 32 17 32ZM16 36H14V34H16V36Z",
    fill: "#0A71FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M25 32H21C20.45 32 20 32.45 20 33V37C20 37.55 20.45 38 21 38H25C25.55 38 26 37.55 26 37V33C26 32.45 25.55 32 25 32ZM24 36H22V34H24V36Z",
    fill: "#0A71FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M33 32H29C28.45 32 28 32.45 28 33V37C28 37.55 28.45 38 29 38H33C33.55 38 34 37.55 34 37V33C34 32.45 33.55 32 33 32ZM32 36H30V34H32V36Z",
    fill: "#0A71FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M38 7C38.5523 7 39 6.55228 39 6C39 5.44772 38.5523 5 38 5C37.4477 5 37 5.44772 37 6C37 6.55228 37.4477 7 38 7Z",
    fill: "#0A71FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M44 13C44.5523 13 45 12.5523 45 12C45 11.4477 44.5523 11 44 11C43.4477 11 43 11.4477 43 12C43 12.5523 43.4477 13 44 13Z",
    fill: "#0A71FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M38.5498 13.8901C39.0398 14.1301 39.6498 13.9401 39.8898 13.4401L43.8898 5.44006C44.1398 4.95006 43.9398 4.35006 43.4398 4.10006C42.9498 3.85006 42.3498 4.05006 42.0998 4.55006L38.0998 12.5501C37.8498 13.0401 38.0498 13.6401 38.5498 13.8901Z",
    fill: "#0A71FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M49 48H44V41.82C45.16 41.4 46 40.3 46 39C46 37.35 44.65 36 43 36C41.35 36 40 37.35 40 39C40 40.3 40.84 41.4 42 41.82V48H38V21.16C39.22 22.62 40.18 23.59 40.29 23.71C40.69 24.09 41.31 24.09 41.71 23.71C42.05 23.37 50 15.34 50 9C50 4.04 45.96 0 41 0C36.04 0 32 4.04 32 9C32 9.97 32.2 10.98 32.52 12H9C8.45 12 8 12.45 8 13V48H4V41.82C5.16 41.4 6 40.3 6 39C6 37.35 4.65 36 3 36C1.35 36 0 37.35 0 39C0 40.3 0.84 41.4 2 41.82V48H1C0.45 48 0 48.45 0 49C0 49.55 0.45 50 1 50H49C49.55 50 50 49.55 50 49C50 48.45 49.55 48 49 48ZM3 40C2.45 40 2 39.55 2 39C2 38.45 2.45 38 3 38C3.55 38 4 38.45 4 39C4 39.55 3.55 40 3 40ZM22 48H17V42H22V48ZM29 48H24V42H29V48ZM36 48H31V41C31 40.45 30.55 40 30 40H16C15.45 40 15 40.45 15 41V48H10V14H33.29C34.03 15.61 35.01 17.18 36 18.58V48ZM34.86 12.64C34.86 12.64 34.84 12.6 34.83 12.58C34.32 11.35 34 10.13 34 9C34 5.14 37.14 2 41 2C44.86 2 48 5.14 48 9C48 13.51 42.91 19.47 41 21.55C39.58 20 36.39 16.29 34.86 12.64ZM43 40C42.45 40 42 39.55 42 39C42 38.45 42.45 38 43 38C43.55 38 44 38.45 44 39C44 39.55 43.55 40 43 40Z",
    fill: "#0A71FE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI12);
export default __webpack_public_path__ + "static/media/i12.7c846ba6b4bb77ea2d4d016b0b9b5c47.svg";
export { ForwardRef as ReactComponent };